import L from 'leaflet';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import 'leaflet-gesture-handling';
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { PortableText } from "@portabletext/react";

export default function Map({ center, zoom, height, markers }) {
  const customIcon = L.icon({
    iconUrl: '/location-lotus.svg',
    iconSize: [60, 60],
    iconAnchor: [30, 60],
    popupAnchor: [0, -60],
  });

  const mapCenter = center ? center : [37.349451032215725, -121.89007902908241];
  const zoomLevel = zoom ? zoom : 12;

  return (
    <MapContainer
      center={mapCenter}
      zoom={zoomLevel}
      maxZoom={19}
      minZoom={9}
      maxBounds={[[36.5, -123.0], [38.1745, -121.0]]}
      gestureHandling={true}
      style={{ height: height, width: '100%' }}
      className="br-300"
      attribution={true}
    >
      <TileLayer
        url="https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png"
        attribution='&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a>, © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {markers.map(marker => {
        let position = [marker.position.lat, marker.position.lng];
        
        return (
          <Marker key={marker._key} position={position} icon={customIcon}>
            {marker.content && <Popup>
              <PortableText value={marker.content} />
            </Popup>}
          </Marker>
        )
      })}
    </MapContainer>
  );
};
